import React, { useEffect, useState } from 'react';
import { ModalSheet } from '@catalogo/ui-americanas-mobile-qna/src/components/molecules/ModalSheet';
import Form from '../../molecules/Form';
import { Button } from './styled';

interface QuestionFormProps {
  productId: string;
  product: any;
  config: any;
  dispatchMetrics: (arg1: string, arg2?: { category: string; action: string; label?: string }) => void;
  className?: 'primary' | 'anchor' | 'text1' | 'text2';
  children: string;
  metricParams?: { category: string; action: string; label?: string };
}

const Component = (props: QuestionFormProps) => {
  const { productId, config, product, dispatchMetrics, children, className, metricParams } = props;
  const [visible, setVisible] = useState(false);
  const faqAcom = 'https://www.americanas.com.br/hotsite/faq-qa';
  const faqSubaShop = `https://www.${config.brandNameLower}.com.br/landingpage/faq-qa`;
  const qnaFaqUrl = config.brand === 'acom' ? faqAcom : faqSubaShop;
  const toggleModal = React.useCallback(() => setVisible(!visible), [visible]);

  const onClick = () => {
    setVisible(true);
    dispatchMetrics('event:track', metricParams);
  };

  const backToForm = () => {
    setVisible(false);
    setVisible(true);
  };

  useEffect(() => {
    const handleAfterClick = (e: any) => {
      const clickOutside = e?.target?.className.includes('src__Wrapper');

      if (clickOutside) {
        toggleModal();
      }
    };

    if (visible) {
      document.addEventListener('click', handleAfterClick);
    }

    return () => {
      document.removeEventListener('click', handleAfterClick);
    };
  }, [visible, toggleModal]);

  return (
    <>
      <Button onClick={onClick} className={className}>
        {children}
      </Button>
      <ModalSheet key="questionForm" visible={visible} exitFunc={() => setVisible(false)}>
        {visible && (
          <Form
            productId={productId}
            productName={product?.name}
            productImage={product?.images}
            qnaFaqUrl={qnaFaqUrl}
            history={history}
            dispatchMetrics={dispatchMetrics}
            backToForm={backToForm}
          />
        )}
      </ModalSheet>
    </>
  );
};

const QuestionForm = Component;

export { QuestionForm };
export default QuestionForm;
